import Vue from 'vue'
import axios from 'axios';
import App from "@/App";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from "vue-router";
import ShareDynamic from "@/pages/share/Dynamic/index";
import ShareVideo from "@/pages/share/Video";
import ShareLive from "@/pages/share/Live";
import {Notification} from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import Download from "@/pages/download";
import Share from "@/pages/share";
import Open from "@/pages/open";
import LoginPhone from "./pages/login-phone";
import Recharge from "./pages/recharge";
import IosDownload from "./pages/ios-download";
import Lottery from "@/pages/lottery.vue";
import Treasure from "@/pages/treasure.vue";
import VueLuckyCanvas from '@lucky-canvas/vue'
import {Col, Row, Overlay} from 'vant';
import * as crypto from './lib/crypto';
import 'vant/lib/index.css';

// 无需加密接口白名单
const whiteList = [
    "/api/message/sms/send-code",
    "/api/system/system/version/last",
];

// Axios 请求拦截器
axios.interceptors.request.use((config) => {
    // 添加请求头
    config.headers["token"] = config.headers.token ?? sessionStorage.getItem("Token");
    config.headers["x-version"] = 35;
    config.headers["x-platform"] = "Ios";
    config.headers["x-enabled-location"] = false;
    config.headers["x-device-id"] = "dev-test";
    config.headers["isEmulator"] = false;
    config.headers["Content-Type"] = "application/json";

    // 如果当前接口不需要加密，则直接返回
    if (config.url && whiteList.includes(config.url)) {
        return config;
    }

    // 接口加密
    config.data = crypto.encrypt("045FE30EC69F2BDF2BD417B13203DE27869F80A257B2EB757EB0A7BCBE76C9E193D1998C586E9B828FCC95A5A70BC0178D369059AFEA1C85B622A393C77353BA81", config.data);
    return config;
});

// Axios返回拦截
axios.interceptors.response.use((response) => {
    // 处理响应数据
    if (response.data.encryptData) {
        const data = crypto.decrypt("1C03EFE38D0EFF12AEC8F3CA309B157F964510FE3D5230EDA9D1BB738C30CCFA", response);
        if (data.code !== 200) {
            Notification({
                title: '请求错误',
                message: response.data.msg ?? "请求错误，请联系管理员处理!",
                type: 'error'
            });
        }
        return data;
    }


    if (response.status !== 200) {
        Notification({
            title: '请求出现异常，请与管理员联系!',
            message: "请求出现异常，请与管理员联系!",
            type: 'error'
        });
        return response.data;
    }

    if (response.data.code && response.data.code !== 200) {
        Notification({
            title: '请求错误',
            message: response.data.msg ?? "请求错误，请联系管理员处理!",
            type: 'error'
        });


        // 如果是未登陆，则跳转到登陆页面
        if (response.data.code === 401) {
            sessionStorage.setItem("Token", undefined);
            location.href = "/login-phone" + location.search;
            return response.data;
        }

        return response.data;
    }

    return response.data;
}, function (error) {
    console.error(error)
    Notification({
        title: '与服务器通信失败',
        message: "您好，您与服务器通信失败。这可能是因为网络不流畅造成的，请刷新页面后重试!",
        type: 'error'
    });
    return Promise.reject(error);
});


// 动态标题修改 使用:<div v-title data-title="我是新的标题"></div>
Vue.directive('title', {
    inserted: function (el) {
        document.title = el.dataset.title
    }
})


Vue.use(Col);
Vue.use(Row);
Vue.use(Overlay);

// Vue 配置
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueClipboard)
Vue.use(VueLuckyCanvas)
new Vue({
    // 路由配置
    router: new VueRouter({
        mode: 'history',
        routes: [
            {path: '/', component: Download},
            {path: '/open', component: Open},
            {path: '/lottery', component: Lottery},
            {path: '/treasure', component: Treasure},
            {path: '/login-phone', component: LoginPhone},
            {path: '/recharge', component: Recharge},
            {path: '/share', component: Share},
            {path: '/share/live', component: ShareLive,},
            {path: '/share/dynamic', component: ShareDynamic,},
            {path: '/share/video', component: ShareVideo,},
            {path: '/ios-download', component: IosDownload,},
        ]
    }),
    render: h => h(App),
}).$mount('#app')